import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
    return (
        <Card className="project-card-view">
            <Card.Img
                variant="top"
                src={props.imgPath}
                alt={props.title}
                className="project-card-image"
            />
            <Card.Body className="project-card-body">
                <Card.Title className="project-card-title">
                    {props.title}
                </Card.Title>
                <Card.Text className="project-card-description">
                    {props.description}
                </Card.Text>

                <div className="project-card-actions">
                    {props.ghLink && (
                        <Button
                            variant="primary"
                            href={props.ghLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-card-btn"
                            aria-label={`Code source GitHub de ${props.title}`}
                        >
                            <BsGithub /> &nbsp;
                            {props.isBlog ? "Blog" : "GitHub"}
                        </Button>
                    )}

                    {!props.isBlog && props.demoLink && (
                        <Button
                            variant="primary"
                            href={props.demoLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-card-btn"
                            aria-label={`Démo en direct de ${props.title}`}
                        >
                            <CgWebsite /> &nbsp; Demo
                        </Button>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

ProjectCards.propTypes = {
    imgPath: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ghLink: PropTypes.string,
    demoLink: PropTypes.string,
    isBlog: PropTypes.bool,
};

ProjectCards.defaultProps = {
    ghLink: null,
    demoLink: null,
    isBlog: false,
};

export default ProjectCards;
